import React, {  useContext } from "react";
import { Container, Row, Col, Table, Form } from "react-bootstrap";
import _ from "lodash";
import moment from "moment";
import CommonUtils from "../../utils/commonUtils";
import { SummaryContext } from "../../context/SummaryContext";
import {UserContext} from "../../context/UserContext";
import "../../styles/summary.scss";
import { StyledBlueButton } from "../../styles/BootstrapStyles";
import { PERMITTED_ROLES, UserRoles } from "../../constants/UserRoles";
import useStoreConfig from "../../hooks/useStoreConfig";
const AUDIT_ACTION_WROTE = "Wrote";

const HistorySummary = () => {
  const { job, onNotesAdded } = useContext(SummaryContext);
  const {userRole}=useContext(UserContext);
  const { ConfigStore } = useStoreConfig();

  const renderHistoryTable = (jobArray) => {
    let sourceTypes = ConfigStore.sourceTypes();
    return (
      <Table
        className="historyTable"
        id={"History_Summary_Table"}>
        <thead
          id={"History_summary_header"}
          className="historyTableHead">
          <tr key={"History_summary_header_row"}>
            <th key={"History_summary_header_date"} className="historyTableLabel">
              Date
            </th>
            <th
              key={"History_summary_header_action"}
              className={"historyTableLabelLarge"}
            >
              Action
            </th>
            <th key={"History_summary_header_author"} className="historyTableLabel">
              Author
            </th>
          </tr>
        </thead>
        <tbody
          style={{
            display: "block",
          }}
          id={"History_summary_table_body"}
        >
          {_.map(_.get(jobArray, "auditTrail", []), (audit, index) => {
            const action = CommonUtils.parseAudit(audit, userRole, _.get(jobArray,"jobType"), sourceTypes);
           // To ensure only UI note actions are filtered correctly, without affecting other audit actions.
            const hideRequestorNotes =
              userRole === UserRoles.REQUESTOR &&
              audit.action === AUDIT_ACTION_WROTE &&
              !audit.notifyClient;

            return (!action && userRole === UserRoles.REQUESTOR) ||
              (audit.field === '/sourceType' && !_.includes(PERMITTED_ROLES.MODAL_SOURCE_LOCATION_ROLES, userRole)) ||
              (audit.field === '/completedDate') || hideRequestorNotes
              ? null : (
                <tr
                  className="historyTableHead"
                  key={"auditTrail_row" + index}
                >
                  <td className="historyTableInput" key={"auditTrail_cell_date" + index}>
                    {moment(_.get(audit, "createdDate", "")).format(
                      "MM/DD/YY H:mm"
                    )}
                  </td>
                  <td
                    className="historyTableInputLarge"
                    key={"auditTrail_cell_action" + index}
                  >
                    {action}
                  </td>
                  <td
                    className="historyTableInput"
                    key={"auditTrail_cell_createdBy" + index}
                  >
                    {_.get(audit, "createdBy")}
                  </td>
                </tr>
              );
          })}
        </tbody>
      </Table>
    );
  };

  const renderAddNotes = () => {
    if (_.includes(["requestor", "adminwithreadaccess", "cr_api", "mediarequest"], userRole) || 
    ((userRole === UserRoles.GLOBALADMIN || userRole === UserRoles.SUPERADMIN || userRole === UserRoles.OPS) && (_.get(job, 'jobType') === 'CONTENT_REQUEST_API' ||  _.get(job, 'jobType') === 'MEDIA_REQUEST'))) {
      return null;
    }
    return (
      <Container
        fluid
        className="w-100 m-0 p-0">
        <label className="historyTitle">
          Add Notes
        </label>
        <Row className="noteRow">
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              let noteRequest = {
                note: e.target.notes.value,
                notifyClient: e.target.notifyClient.checked,
              };
              if (_.isEmpty(_.get(noteRequest, "note", "").trim())) {
                e.target.notes.value = "";
                return;
              }
              onNotesAdded(noteRequest);
              e.target.notes.value = "";
              e.target.notifyClient.checked = false;
            }}
          >
            <Form.Group controlId="notes">
              <Form.Control
                as="textarea"
                required={true}
                placeholder={"Notes"}
                className="formNote"
              />
            </Form.Group>
            <Form.Row>
              <Col xs={6} className="m-0 p-0">
                <Form.Group controlId="notifyClient">
                  <Form.Check
                    className="notifyClient"
                    inline
                    type="checkbox"
                    label="Notify Client?"
                  />
                </Form.Group>
              </Col>
              <Col
                xs={6}
                className="saveNote"
              >
                <StyledBlueButton
                  type="submit"
                >
                  Save Note
                </StyledBlueButton>
              </Col>
            </Form.Row>
          </Form>
        </Row>
      </Container>
    );
  };

    return _.isEmpty(job) || !_.has(job, "auditTrail", []) ? null : (
        <>
            <div className="p-0 mx-0 mt-0 mb-4">
                <label className="historyTitle">
                    History
                </label>
                <div>{renderHistoryTable(job)}</div>
            </div>
            <div className="w-100">
                {renderAddNotes()}
            </div>
        </>
    );
};

export default HistorySummary;
